import React from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import MainSection from "../../components/mainLayout/Main";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import ViewReportTask from "./ViewReportTask";

const ViewReportTaskPage = () => {
  return (
    <>
      <Sidebar />
      <MainSection>
        <SectionHeader title="Report Detail" />
        <ViewReportTask />
      </MainSection>
    </>
  );
};

export default ViewReportTaskPage;
